import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { SocialLogin } from "app/account/social-login";
import { getCookie } from "../../shared/cookie";

/**
 * Handle OneDrive login before loading a component
 */
@Injectable({
   providedIn: "root",
})
export class OneDriveAuthGuardService  {
   constructor(private socialLogin: SocialLogin) {}

   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
      if (window.localStorage.getItem("access_token")) {
         return true;
      }
      const currentCookie = getCookie("odauth");
      if (currentCookie) {
         window.localStorage.setItem("access_token", currentCookie);
         return true;
      }
      return this.socialLogin.withMicrosoft().pipe(
         map( (userOneDriveProfile) => {
            if (userOneDriveProfile?.accessToken === localStorage.getItem('access_token')) {
               // Success login OneDrive
               return true;
            }
            return false;
         })
      );
   }
}
